module.exports = __webpack_public_path__ + "img/Transaction-Function.493c9354.png";